<script context="module">
    /** static properties so we can have unique ids for each Select */
    export let _id = 1;
</script>

<script lang="ts">
    import Fieldset from './Fieldset.svelte';
    // interface Option {
    //     name: string;
    //     value: string;
    // };
    // export let options: Option = [];
    const generatedId = `vv-select-${_id++}`;
    let _class = '';
    export { _class as class};
    export let fieldsetClass = '';
    export let labelClass = "";
    export let placeholder = "";
	export let errors: string[] = [];

    export let id = '';
    export let value = '';
    export let onBeforeInput = (value: string, e: Event) => {};
</script>

<Fieldset {fieldsetClass} {labelClass} for={id || generatedId}>
    <slot name="label" slot="label"></slot>
    <select id={id || generatedId} class="rounded px-1 pt-[5px] pb-[6px] w-full
        border-solid border-2 border-gray-300
        outline-gray-600        
        {$$slots.error || errors.length  ? 'border-vv-red-fire' : ''}
        {_class}
        "
        on:input={(e) => onBeforeInput(value, e)}
        bind:value 
        on:input
        on:change
        {...$$restProps}
    >
        {#if placeholder && placeholder.length}
            <option value="">{placeholder}</option>
        {/if}
        <slot></slot>
    </select>
    <slot name="error" slot="error"></slot>   
	{#if errors.length}
		<ul class="text-vv-red-fire">
			{#each errors as error}
				<li>{error}</li>
			{/each}
		</ul>
	{/if}
</Fieldset>